import React from 'react';
import {
  AuditOutlined,
  BarsOutlined,
  CheckCircleOutlined,
  HomeOutlined,
  ProfileOutlined,
  SafetyOutlined,
  SearchOutlined,
} from '@ant-design/icons';

const HOME = [
  {
    name: 'Home',
    icon: <HomeOutlined />,
    path: 'home',
    entity: 'frontoffice_home',
  },
  {
    name: 'Home piracy',
    icon: <HomeOutlined />,
    path: 'home-piracy',
    entity: 'frontoffice_home_piracy',
  },
  {
    name: 'Home impersonations',
    icon: <HomeOutlined />,
    path: 'home-impersonations',
    entity: 'frontoffice_home_impersonation',
  },
];

const DETECTION = {
  name: 'Detection',
  icon: <SearchOutlined />,
  path: 'detection',
  children: [
    {
      name: 'Asset Verification',
      path: 'asset-verification',
      entity: 'frontoffice_detection_assetverification',
    },
    {
      name: 'New Incident',
      path: 'new-incident',
      entity: 'frontoffice_detection_newincident',
    },
  ],
};

const VALIDATION = {
  name: 'Validation',
  icon: <CheckCircleOutlined />,
  path: 'validation',
  children: [
    {
      name: 'Infringement Evaluation',
      path: 'infringement-evaluation',
      entity: 'frontoffice_validation_infringementevaluation',
    },
    {
      name: 'Infringement Confirmation',
      path: 'infringement-confirmation',
      entity: 'frontoffice_validation_infringementconfirmation',
    },
  ],
};

const ENFORCEMENT = {
  name: 'Enforcement',
  icon: <SafetyOutlined />,
  path: 'enforcement',
  children: [
    {
      name: 'Notice Sending',
      path: 'notice-sending',
      entity: 'frontoffice_enforcement_noticesending',
    },
  ],
};

const REPORTING = {
  name: 'Reporting',
  icon: <BarsOutlined />,
  path: 'reporting',
  children: [
    {
      name: 'All incidents ',
      path: 'all-incidents',
      entity: 'frontoffice_reporting_allincidents',
    },
    {
      name: 'All incidents',
      path: 'all-incidents-customer',
      entity: 'frontoffice_reporting_allincidents_customerview',
    },
    {
      name: 'Jira Management',
      path: 'jira-management',
      entity: 'frontoffice_reporting_jiramanagement',
    },
  ],
};

const TASKS = {
  name: 'Task',
  icon: <ProfileOutlined />,
  path: 'tasks',
  children: [
    {
      name: 'Reported Incidents',
      path: 'reported-incidents',
      entity: 'frontoffice_tasks_reported_incidents',
    },
    {
      name: 'Data completion',
      path: 'data-completion',
      entity: 'frontoffice_tasks_datacompletion',
    },
    {
      name: 'Evidence collection',
      path: 'test-purchase',
      entity: 'frontoffice_tasks_testpurchase',
    },
    {
      name: 'Shortener resolution',
      path: 'shortener-resolution',
      entity: 'frontoffice_tasks_linkresolution',
    },
    {
      name: 'Manual Enforcement',
      path: 'manual-enforcement',
      entity: 'frontoffice_tasks_manualenforcement',
    },
    {
      name: 'Image recognition',
      path: 'image-recognition',
      entity: 'frontoffice_tasks_imagerecognition',
    },
    {
      name: 'Links management',
      path: 'links-management',
      entity: 'frontoffice_tasks_links_management',
    },
    {
      name: 'Facilitator validation',
      path: 'facilitator-validation',
      entity: 'frontoffice_tasks_facilitatorvalidation',
    },
  ],
};

const ASSET_AUDIT = {
  name: 'Asset audit',
  icon: <AuditOutlined />,
  path: 'asset-audit',
  children: [
    {
      name: 'Audit results',
      path: 'audit-results',
      entity: 'frontoffice_assetaudit_results',
    },
    {
      name: 'New Incident',
      path: 'new-incident',
      entity: 'frontoffice_assetaudit_newincident',
    },
    {
      name: 'Asset verification',
      path: 'asset-verification',
      entity: 'frontoffice_assetaudit_assetverification',
    },
    {
      name: 'Infringement Evaluation',
      path: 'infringement-evaluation',
      entity: 'frontoffice_assetaudit_infringementevaluation',
    },
  ],
};

export default [
  ...HOME,
  DETECTION,
  VALIDATION,
  ENFORCEMENT,
  REPORTING,
  TASKS,
  ASSET_AUDIT,
];
